import { useState } from "react";
import moment from "moment-timezone";
import NavItem from "../NavItem";
import { Popover } from 'antd';
import FeatherIcon from 'feather-icons-react';
import Restricted from "../../../PermissionsProvider/Restricted";
import { Button } from "../../atoms/buttons/buttons";
import shiftApi from "../../../utilities/api/shift";
import openNotification from "../../../utilities/openNotification";
import { DownloadOutlined } from "@ant-design/icons";

export default function DigitalSchedulerDownloadCTA({ id }) {
    const [isExportingLoading, setIsExportingLoading] = useState(false);

    const exportAsPDF = async (type = "pdf") => {
        try {
            setIsExportingLoading(true);
            let response = type === "pdf" ? await shiftApi.exportApptPDF(id) : await shiftApi.exportApptCSV(id);
            let today = moment();
            let date = today.format("YYYY-MMMM-DD [at] HH:mm:ss");

            const url = URL.createObjectURL(
                new Blob([response.data], {
                    type: type === "pdf" ? "application/pdf" : "text/csv;charset=utf-8",
                })
            );
            let link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `Shift-#${id}-${date}.${type === "pdf" ? "pdf" : "csv"}`
            );

            document.body.appendChild(link);
            link.click();
            link.remove();
            setIsExportingLoading(false);
            openNotification("Success", "Shift Data exported successfully", "success", 2);
        } catch (err) {
            console.log({ err });
            setIsExportingLoading(false);
            openNotification("Error", err.response.message, "error", 2);
        }
    };

    const content = (
        <>
            <NavItem
                className="mb-8"
                id="export-pdf"
                to="#"
                onClick={() => exportAsPDF()}
                text={<span>PDF</span>}
                icon={
                    <FeatherIcon size={16} icon="book-open" className="mr-8" />
                }
            />
            <NavItem
                className="mb-8"
                id="export-csv"
                to="#"
                onClick={() => exportAsPDF("csv")}
                text={<span>CSV</span>}
                icon={<FeatherIcon size={16} icon="file" className="mr-8" />}
            />
        </>
    );

    return (
        <Restricted to="export" resource="appointment" fallback={<></>}>
            <Popover
                placement="bottomRight"
                content={content}
                trigger="click"
            >
                <Button
                    className="mb-16"
                    size="small"
                    type="light"
                    icon={<DownloadOutlined />}
                >
                    Export
                </Button>
            </Popover>
        </Restricted>)

};